// dome

export default [
  // dome
  {
    path: '/dome',
    name: 'Dome',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/dome/dome')
  },
  // dome
  {
    path: '/demo',
    name: 'Demo',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/dome/demo')
  },
  {
    path: '/check',
    name: 'Check',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/dome/device')
  },
  {
    path: '/pagination',
    name: 'Pagination',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/dome/pagination')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/dome.js